import { create } from "zustand";
import { transferCount } from "../api_layer/api";

export const useRecentTransfer = create((set) => ({
  transferData: [],
  transferLoading: false,
  isError: false,
  errorMessage: "",
  fetchTransferData: async () => {
    try {
      set({ transferLoading: true, error: null });
      const response = await transferCount();
      set({transferData: response.data, transferLoading:false });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ transferLoading: false });
    }
  },
}));
